export const data = [
  {
    id: 652078,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 2,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 89.0,
      healthScore: 87.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 100.84,
      extendedIngredients: [
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "2 cups of water",
          originalName: "water",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 10011457,
          aisle: "Produce",
          image: "spinach.jpg",
          consistency: "solid",
          name: "spinach",
          nameClean: "spinach",
          original: "bunch of fresh spinach",
          originalName: "fresh spinach",
          amount: 1.0,
          unit: "bunch",
          meta: ["fresh"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "bunch",
              unitLong: "bunch",
            },
            metric: {
              amount: 1.0,
              unitShort: "bunch",
              unitLong: "bunch",
            },
          },
        },
        {
          id: 16213,
          aisle: "Refrigerated;Produce;Ethnic Foods",
          image: "tofu.png",
          consistency: "solid",
          name: "tofu",
          nameClean: "tofu",
          original: "1/2 of a block of firm tofu",
          originalName: "a block of firm tofu",
          amount: 0.5,
          unit: "",
          meta: ["firm"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 0.5,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11260,
          aisle: "Produce",
          image: "mushrooms-white.jpg",
          consistency: "solid",
          name: "mushrooms",
          nameClean: "fresh mushrooms",
          original: "8 shitaki mushrooms, cut up lengthwise",
          originalName: "shitaki mushrooms, cut up lengthwise",
          amount: 8.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 8.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 8.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11156,
          aisle: "Produce",
          image: "fresh-chives.jpg",
          consistency: "solid",
          name: "chives",
          nameClean: "chives",
          original: "2 smalls chives, cut into squares",
          originalName: "s chives, cut into squares",
          amount: 2.0,
          unit: "small",
          meta: ["cut into squares"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "small",
              unitLong: "smalls",
            },
            metric: {
              amount: 2.0,
              unitShort: "small",
              unitLong: "smalls",
            },
          },
        },
        {
          id: 10511282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "yellow onion",
          nameClean: "yellow onion",
          original: "1 yellow onion, chopped up",
          originalName: "yellow onion, chopped up",
          amount: 1.0,
          unit: "",
          meta: ["yellow", "chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 20133,
          aisle: "Pasta and Rice;Gluten Free;Ethnic Foods",
          image: "dried-rice-noodles.jpg",
          consistency: "solid",
          name: "rice noodles",
          nameClean: "rice vermicelli",
          original: "1/2 package of a of Thai Kitchen Thin Rice Noodles",
          originalName: "a of Thai Kitchen Thin Rice Noodles",
          amount: 0.5,
          unit: "package",
          meta: ["thin"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "pkg",
              unitLong: "packages",
            },
            metric: {
              amount: 0.5,
              unitShort: "pkg",
              unitLong: "packages",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger",
          nameClean: "ginger",
          original: "1 ginger",
          originalName: "ginger",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11298,
          aisle: "Produce",
          image: "parsnip.jpg",
          consistency: "solid",
          name: "parsnip",
          nameClean: "parsnip",
          original: "1 parsnip, cut up",
          originalName: "parsnip, cut up",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11960,
          aisle: "Produce",
          image: "baby-carrots.jpg",
          consistency: "solid",
          name: "baby carrots",
          nameClean: "baby carrots",
          original: "6 baby carrots, cut up",
          originalName: "baby carrots, cut up",
          amount: 6.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11477,
          aisle: "Produce",
          image: "zucchini.jpg",
          consistency: "solid",
          name: "zucchini",
          nameClean: "zucchini",
          original: "1 zucchini, cut up",
          originalName: "zucchini, cut up",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1032009,
          aisle: "Spices and Seasonings",
          image: "red-pepper-flakes.jpg",
          consistency: "solid",
          name: "red pepper flakes",
          nameClean: "red pepper flakes",
          original:
            "pinch of red pepper flakes-taste as you go to adjust flavors",
          originalName:
            "pinch of red pepper flakes-taste as you go to adjust flavors",
          amount: 1.0,
          unit: "pinch",
          meta: ["red"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "pinch",
              unitLong: "pinch",
            },
            metric: {
              amount: 1.0,
              unitShort: "pinch",
              unitLong: "pinch",
            },
          },
        },
        {
          id: 2021,
          aisle: "Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger powder",
          nameClean: "ginger powder",
          original: "pinch of ginger powder-taste as you go to adjust flavors",
          originalName:
            "pinch of ginger powder-taste as you go to adjust flavors",
          amount: 1.0,
          unit: "pinch",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "pinch",
              unitLong: "pinch",
            },
            metric: {
              amount: 1.0,
              unitShort: "pinch",
              unitLong: "pinch",
            },
          },
        },
      ],
      id: 652078,
      title: "Miso Soup With Thin Noodles",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl:
        "https://www.foodista.com/recipe/BYJ4Q2M5/miso-soup-with-thin-noodles",
      image: "https://spoonacular.com/recipeImages/652078-556x370.jpg",
      imageType: "jpg",
      summary:
        'Miso Soup With Thin Noodles is a soup that serves 8. For <b>$1.01 per serving</b>, this recipe <b>covers 17%</b> of your daily requirements of vitamins and minerals. One serving contains <b>114 calories</b>, <b>5g of protein</b>, and <b>2g of fat</b>. It is brought to you by Foodista. It is a good option if you\'re following a <b>dairy free, lacto ovo vegetarian, and vegan</b> diet. Head to the store and pick up pepper flakes-taste as you go to adjust flavors, parsnip, ginger, and a few other things to make it today. Not a lot of people made this recipe, and 1 would say it hit the spot. It can be enjoyed any time, but it is especially good for <b>Autumn</b>. From preparation to the plate, this recipe takes roughly <b>roughly 45 minutes</b>. This recipe is typical of Japanese cuisine. Overall, this recipe earns an <b>awesome spoonacular score of 89%</b>. Similar recipes include <a href="https://spoonacular.com/recipes/a-quick-and-easy-soup-miso-soup-with-soba-noodles-or-mung-bean-31003">A Quick And Easy Soup {miso Soup With Soba Noodles Or Mung Bean</a>, <a href="https://spoonacular.com/recipes/cold-miso-sesame-noodles-991641">Cold Miso-Sesame Noodles</a>, and <a href="https://spoonacular.com/recipes/soba-noodles-with-miso-broth-37466">Soba Noodles with Miso Broth</a>.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["soup"],
      diets: ["dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: ["fall", "winter"],
      winePairing: {
        pairedWines: ["riesling", "sake", "sauvignon blanc"],
        pairingText:
          "Riesling, Sake, and Sauvignon Blanc are my top picks for Miso Soup. Saké is an obvious choice when it comes to Japanese food. If you want to stick to grape wine, though, you might opt for sauvignon blanc or riesling. The Selbach Oster Zeltinger Himmelreich Riesling Kabinett Halbtrocken with a 4 out of 5 star rating seems like a good match. It costs about 21 dollars per bottle.",
        productMatches: [
          {
            id: 2041332,
            title:
              "Selbach Oster Zeltinger Himmelreich Riesling Kabinett Halbtrocken",
            description:
              "#95 Wine Spectator Top 100 of 2017\nIt’s richer and less minty than usual but I like the richness in this vintage, which can use a little gras; so anticipate a wine with more apple and less spearmint; crunchy stuff. The parcel is called Heel and it’s to the right of Anrecht, from which one of the great trio of en-bloc wines comes.",
            price: "$20.99",
            imageUrl:
              "https://spoonacular.com/productImages/2041332-312x231.jpg",
            averageRating: 0.8,
            ratingCount: 10.0,
            score: 0.767741935483871,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fselbach-oster-zeltinger-himmelreich-riesling-kabinett-halbtrocken-2015%2F163765",
          },
        ],
      },
      instructions:
        'Directions:\nAfter the miso has been prepared, start adding the "stuff" to the soup pot. It can be your preference, but I opted to start with the onions and chives and then added the zucchini, parsnip, carrots, mushrooms and ginger. Cover the pot and let cook on a low flame for 20-30 minutes, tasting as you go. Add the tofu and pasta, allowing the pasta to cook for 8-10 minutes. Taste the soup, adding red pepper and turn off flame when ready. Place spinach on the bottom of your soup bowl. You can also place the spinach directly in the pot, but since it wilts so quickly I usually do it this way.\nWhat do you usually add to your Miso Soup?\nSeriously Soupy Serena',
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: 'After the miso has been prepared, start adding the "stuff" to the soup pot. It can be your preference, but I opted to start with the onions and chives and then added the zucchini, parsnip, carrots, mushrooms and ginger. Cover the pot and let cook on a low flame for 20-30 minutes, tasting as you go.',
              ingredients: [
                {
                  id: 11260,
                  name: "mushrooms",
                  localizedName: "mushrooms",
                  image: "mushrooms.png",
                },
                {
                  id: 11477,
                  name: "zucchini",
                  localizedName: "zucchini",
                  image: "zucchini.jpg",
                },
                {
                  id: 11124,
                  name: "carrot",
                  localizedName: "carrot",
                  image: "sliced-carrot.png",
                },
                {
                  id: 11298,
                  name: "parsnip",
                  localizedName: "parsnip",
                  image: "parsnip.jpg",
                },
                {
                  id: 11156,
                  name: "chives",
                  localizedName: "chives",
                  image: "fresh-chives.jpg",
                },
                {
                  id: 11216,
                  name: "ginger",
                  localizedName: "ginger",
                  image: "ginger.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 16112,
                  name: "miso",
                  localizedName: "miso",
                  image: "miso.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 30,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Add the tofu and pasta, allowing the pasta to cook for 8-10 minutes. Taste the soup, adding red pepper and turn off flame when ready.",
              ingredients: [
                {
                  id: 11821,
                  name: "red pepper",
                  localizedName: "red pepper",
                  image: "red-pepper.jpg",
                },
                {
                  id: 20420,
                  name: "pasta",
                  localizedName: "pasta",
                  image: "fusilli.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
                {
                  id: 16213,
                  name: "tofu",
                  localizedName: "tofu",
                  image: "tofu.png",
                },
              ],
              equipment: [],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Place spinach on the bottom of your soup bowl. You can also place the spinach directly in the pot, but since it wilts so quickly I usually do it this way.",
              ingredients: [
                {
                  id: 10011457,
                  name: "spinach",
                  localizedName: "spinach",
                  image: "spinach.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "What do you usually add to your Miso Soup?",
              ingredients: [
                {
                  id: 0,
                  name: "miso soup",
                  localizedName: "miso soup",
                  image: "",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Seriously Soupy Serena",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/miso-soup-with-thin-noodles-652078",
    },
  },
  {
    id: 634710,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 10,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 5,
      spoonacularScore: 85.0,
      healthScore: 41.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 332.75,
      extendedIngredients: [
        {
          id: 10011090,
          aisle: "Produce",
          image: "broccoli.jpg",
          consistency: "solid",
          name: "broccoli florets",
          nameClean: "broccoli florets",
          original: "2 cups broccoli florets",
          originalName: "broccoli florets",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 tablespoon brown sugar",
          originalName: "brown sugar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 20027,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "cornstarch",
          nameClean: "corn starch",
          original: "1 tablespoon cornstarch",
          originalName: "cornstarch",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 1004058,
          aisle: "Ethnic Foods",
          image: "sesame-oil.png",
          consistency: "liquid",
          name: "dark sesame oil",
          nameClean: "dark sesame oil",
          original: "1 teaspoon dark sesame oil",
          originalName: "dark sesame oil",
          amount: 1.0,
          unit: "teaspoon",
          meta: ["dark"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 23657,
          aisle: "Meat",
          image: "flank-steak.jpg",
          consistency: "solid",
          name: "flank steak",
          nameClean: "flank steak",
          original: '1/2 pound beef sirloin or flank steak, cut into ½" strips',
          originalName: 'beef sirloin or flank steak, cut into ½" strips',
          amount: 0.5,
          unit: "pound",
          meta: ['cut into ½" strips'],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 226.796,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "1 teaspoon garlic, minced",
          originalName: "garlic, minced",
          amount: 1.0,
          unit: "teaspoon",
          meta: ["minced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger",
          nameClean: "ginger",
          original: "1 tablespoon ginger, peeled and minced",
          originalName: "ginger, peeled and minced",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["minced", "peeled"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 11260,
          aisle: "Produce",
          image: "mushrooms-white.jpg",
          consistency: "solid",
          name: "mushrooms",
          nameClean: "fresh mushrooms",
          original: "1 cup chopped mushrooms",
          originalName: "chopped mushrooms",
          amount: 1.0,
          unit: "cup",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 4582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vegetable-oil.jpg",
          consistency: "liquid",
          name: "oil",
          nameClean: "cooking oil",
          original: "6 teaspoons Oil",
          originalName: "Oil",
          amount: 6.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 6.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 11821,
          aisle: "Produce",
          image: "red-pepper.jpg",
          consistency: "solid",
          name: "red bell pepper",
          nameClean: "red pepper",
          original: "1 cup sliced red bell pepper",
          originalName: "sliced red bell pepper",
          amount: 1.0,
          unit: "cup",
          meta: ["red", "sliced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11291,
          aisle: "Produce",
          image: "spring-onions.jpg",
          consistency: "solid",
          name: "scallions",
          nameClean: "spring onions",
          original: "2 tablespoons chopped scallions",
          originalName: "chopped scallions",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 12023,
          aisle: "Ethnic Foods;Spices and Seasonings",
          image: "sesame-seeds.png",
          consistency: "solid",
          name: "sesame seeds",
          nameClean: "sesame seeds",
          original: "2 teaspoons sesame seeds, toasted",
          originalName: "sesame seeds, toasted",
          amount: 2.0,
          unit: "teaspoons",
          meta: ["toasted"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 16124,
          aisle: "Ethnic Foods;Condiments",
          image: "soy-sauce.jpg",
          consistency: "liquid",
          name: "soy sauce",
          nameClean: "soy sauce",
          original: "1/4 cup soy sauce",
          originalName: "soy sauce",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 634710,
      title: "Beef Teriyaki Stir Fry",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl:
        "http://www.foodista.com/recipe/WCTVNX24/beef-teriyaki-stir-fry",
      image: "https://spoonacular.com/recipeImages/634710-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe Beef Teriyaki Stir Fry is ready <b>in around 45 minutes</b> and is definitely an excellent <b>gluten free and dairy free</b> option for lovers of Japanese food. For <b>$3.33 per serving</b>, this recipe <b>covers 35%</b> of your daily requirements of vitamins and minerals. This recipe makes 2 servings with <b>418 calories</b>, <b>33g of protein</b>, and <b>21g of fat</b> each. It works well as a main course. This recipe from Foodista has 5 fans. A mixture of sesame oil, brown sugar, scallions, and a handful of other ingredients are all it takes to make this recipe so tasty. To use up the ginger you could follow this main course with the <a href="https://spoonacular.com/recipes/ginger-cake-with-crystallized-ginger-frosting-189279">Ginger Cake with Crystallized Ginger Frosting</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 86%</b>. This score is excellent. Try <a href="https://spoonacular.com/recipes/quick-10-minute-shrimp-teriyaki-stir-fry-919987">Quick 10 Minute Shrimp Teriyaki Stir-Fry</a>, <a href="https://spoonacular.com/recipes/mongolian-beef-stir-fry-928521">Mongolian Beef Stir-Fry</a>, and <a href="https://spoonacular.com/recipes/beef-and-broccoli-stir-fry-923258">Beef and Broccoli Stir-Fry</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Whisk ingredients together in a small bowl and refrigerate for at least 30 minutes.</li><li>Heat oil in a large frying pan over medium heat. Add beef and saut for 3-4 minutes just to brown it on all sides.</li><li>Remove from pan and set aside.</li><li>Add vegetables and saut for 5 minutes more, until beginning to soften.</li><li>Stir in teriyaki sauce and allow mixture to come to a simmer.</li><li>Add beef and any drippings that have accumulated on the plate. Cook for 5 minutes, stirring occasionally.</li><li>In a small bowl, combine cornstarch with 2 tsp cold water to dissolve. Stir into the pan of beef and vegetables. Allow the mixture to simmer and thicken for 2 minutes. Toss to evenly coat vegetables and beef in teriyaki sauce. Serve.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Whisk ingredients together in a small bowl and refrigerate for at least 30 minutes.",
              ingredients: [],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 30,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Heat oil in a large frying pan over medium heat.",
              ingredients: [
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 3,
              step: "Add beef and saut for 3-4 minutes just to brown it on all sides.",
              ingredients: [
                {
                  id: 23572,
                  name: "beef",
                  localizedName: "beef",
                  image: "beef-cubes-raw.png",
                },
              ],
              equipment: [],
              length: {
                number: 4,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Remove from pan and set aside.",
              ingredients: [],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 5,
              step: "Add vegetables and saut for 5 minutes more, until beginning to soften.Stir in teriyaki sauce and allow mixture to come to a simmer.",
              ingredients: [
                {
                  id: 6112,
                  name: "teriyaki sauce",
                  localizedName: "teriyaki sauce",
                  image: "dark-sauce.jpg",
                },
                {
                  id: 11583,
                  name: "vegetable",
                  localizedName: "vegetable",
                  image: "mixed-vegetables.png",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Add beef and any drippings that have accumulated on the plate. Cook for 5 minutes, stirring occasionally.In a small bowl, combine cornstarch with 2 tsp cold water to dissolve. Stir into the pan of beef and vegetables. Allow the mixture to simmer and thicken for 2 minutes. Toss to evenly coat vegetables and beef in teriyaki sauce.",
              ingredients: [
                {
                  id: 6112,
                  name: "teriyaki sauce",
                  localizedName: "teriyaki sauce",
                  image: "dark-sauce.jpg",
                },
                {
                  id: 20027,
                  name: "corn starch",
                  localizedName: "corn starch",
                  image: "white-powder.jpg",
                },
                {
                  id: 11583,
                  name: "vegetable",
                  localizedName: "vegetable",
                  image: "mixed-vegetables.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 23572,
                  name: "beef",
                  localizedName: "beef",
                  image: "beef-cubes-raw.png",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 7,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Serve.",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/beef-teriyaki-stir-fry-634710",
    },
  },
  {
    id: 648506,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 10,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 85.0,
      healthScore: 76.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 620.99,
      extendedIngredients: [
        {
          id: 15166,
          aisle: "Seafood",
          image: "octopus.png",
          consistency: "solid",
          name: "octopus",
          nameClean: "octopus",
          original: "Cooked octopus",
          originalName: "Cooked octopus",
          amount: 1.0,
          unit: "serving",
          meta: ["cooked"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 15270,
          aisle: "Seafood",
          image: "shrimp.png",
          consistency: "solid",
          name: "prawns",
          nameClean: "shrimp",
          original: "Cooked prawns",
          originalName: "Cooked prawns",
          amount: 1.0,
          unit: "serving",
          meta: ["cooked"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 10015121,
          aisle: "Seafood",
          image: "canned-tuna.png",
          consistency: "solid",
          name: "tuna",
          nameClean: "tuna",
          original: "Raw tuna",
          originalName: "Raw tuna",
          amount: 1.0,
          unit: "serving",
          meta: ["raw"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 15076,
          aisle: "Seafood",
          image: "salmon.png",
          consistency: "solid",
          name: "salmon",
          nameClean: "salmon",
          original: "Salmon",
          originalName: "Salmon",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 15072,
          aisle: "Seafood",
          image: "salmon-caviar.png",
          consistency: "solid",
          name: "salmon caviar",
          nameClean: "salmon roe",
          original: "Salmon caviar",
          originalName: "Salmon caviar",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 10120054,
          aisle: "Pasta and Rice",
          image: "rice-jasmine-cooked.jpg",
          consistency: "solid",
          name: "sticky rice",
          nameClean: "sticky rice",
          original: "Japanese sticky rice",
          originalName: "Japanese sticky rice",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 11445,
          aisle: "Ethnic Foods;Health Foods",
          image: "kombu.jpg",
          consistency: "solid",
          name: "seaweed",
          nameClean: "kelp",
          original: "Lava seaweed",
          originalName: "Lava seaweed",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 11990,
          aisle: "Ethnic Foods;Spices and Seasonings",
          image: "wasabi.jpg",
          consistency: "solid",
          name: "wasabi",
          nameClean: "wasabi",
          original: "Wasabi",
          originalName: "Wasabi",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 11011,
          aisle: "Produce",
          image: "asparagus.png",
          consistency: "solid",
          name: "asparagus",
          nameClean: "asparagus",
          original: "Asparagus",
          originalName: "Asparagus",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 11238,
          aisle: "Produce",
          image: "shiitake-mushrooms.png",
          consistency: "solid",
          name: "shiitake mushrooms",
          nameClean: "shiitake mushrooms",
          original: "Shiitake mushrooms",
          originalName: "Shiitake mushrooms",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
      ],
      id: 648506,
      title: "Japanese Sushi",
      readyInMinutes: 45,
      servings: 1,
      sourceUrl: "https://www.foodista.com/recipe/ZHC2WBHW/japanese-sushi",
      image: "https://spoonacular.com/recipeImages/648506-556x370.jpg",
      imageType: "jpg",
      summary:
        'Japanese Sushi is a Japanese hor d\'oeuvre. One serving contains <b>564 calories</b>, <b>71g of protein</b>, and <b>13g of fat</b>. For <b>$6.21 per serving</b>, this recipe <b>covers 36%</b> of your daily requirements of vitamins and minerals. This recipe serves 1. A mixture of asparagus, japanese sticky rice, shiitake mushrooms, and a handful of other ingredients are all it takes to make this recipe so flavorful. It is a good option if you\'re following a <b>gluten free, dairy free, and pescatarian</b> diet. 1 person has made this recipe and would make it again. From preparation to the plate, this recipe takes approximately <b>approximately 45 minutes</b>. It is brought to you by Foodista. All things considered, we decided this recipe <b>deserves a spoonacular score of 84%</b>. This score is great. Try <a href="https://spoonacular.com/recipes/chirashi-sushi-cake-and-temari-sushi-540672">Chirashi Sushi Cake and Temari Sushi</a>, <a href="https://spoonacular.com/recipes/deconstructed-sushi-chirashi-sushi-509386">Deconstructed Sushi (Chirashi Sushi)</a>, and <a href="https://spoonacular.com/recipes/japanese-carrot-ginger-salad-dressing-japanese-carrot-ginger-salad-dressing-power-foods-473892">Japanese Carrot Ginger Salad Dressing Japanese Carrot Ginger Salad Dressing (Power Foods)</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: [
        "antipasti",
        "lunch",
        "main course",
        "starter",
        "snack",
        "appetizer",
        "main dish",
        "antipasto",
        "hor d'oeuvre",
        "dinner",
      ],
      diets: ["gluten free", "dairy free", "pescatarian"],
      occasions: [],
      winePairing: {
        pairedWines: [
          "riesling",
          "sake",
          "sauvignon blanc",
          "sparkling rose",
          "sparkling wine",
        ],
        pairingText:
          "Riesling, Sake, and Sauvignon Blanc are great choices for Sushi. If you're serving a selection of appetizers, you can't go wrong with these. Both are very food friendly and complement a variety of flavors. You could try J.J. Prum Graacher Himmelreich Kabinett Riesling. Reviewers quite like it with a 4.4 out of 5 star rating and a price of about 22 dollars per bottle.",
        productMatches: [
          {
            id: 437965,
            title: "J.J. Prum Graacher Himmelreich Kabinett Riesling",
            description:
              "Despite its still youthful freshness it shows the fine fruity Riesling characteristic and an underlying hint of mineral from the blue/grey Devonian slate soil.\n\nServe this refreshing wine slightly chilled! As aperitif and, especially when more matured, in combination with seafood or poultry.",
            price: "$21.99",
            imageUrl:
              "https://spoonacular.com/productImages/437965-312x231.jpg",
            averageRating: 0.8800000000000001,
            ratingCount: 19.0,
            score: 0.8627586206896553,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fjj-prum-graacher-himmelreich-kabinett-riesling-1998%2F9594",
          },
        ],
      },
      instructions:
        "Recipe one: Pour cooked rice into a tray. Finely slice the salmon and the tuna.\nPut the seaweed onto a sushi mat and press rice down onto it.\nSlice the mushrooms and asparagus pieces and lay along the rice. Add the wasabi. Roll the sushi and cut into slices. Serve with salmon caviar, wasabi and soy.\nRecipe two: Squeeze the rice into balls and press the prawns, tuna or salmon into the top.",
      analyzedInstructions: [
        {
          name: "Recipe one",
          steps: [
            {
              number: 1,
              step: "Pour cooked rice into a tray. Finely slice the salmon and the tuna.",
              ingredients: [
                {
                  id: 10220445,
                  name: "cooked rice",
                  localizedName: "cooked rice",
                  image: "uncooked-white-rice.png",
                },
                {
                  id: 15076,
                  name: "salmon",
                  localizedName: "salmon",
                  image: "salmon.png",
                },
                {
                  id: 10015121,
                  name: "tuna",
                  localizedName: "tuna",
                  image: "canned-tuna.png",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Put the seaweed onto a sushi mat and press rice down onto it.",
              ingredients: [
                {
                  id: 11445,
                  name: "seaweed",
                  localizedName: "seaweed",
                  image: "kombu.jpg",
                },
                {
                  id: 20444,
                  name: "rice",
                  localizedName: "rice",
                  image: "uncooked-white-rice.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Slice the mushrooms and asparagus pieces and lay along the rice.",
              ingredients: [
                {
                  id: 11011,
                  name: "asparagus",
                  localizedName: "asparagus",
                  image: "asparagus.png",
                },
                {
                  id: 11260,
                  name: "mushrooms",
                  localizedName: "mushrooms",
                  image: "mushrooms.png",
                },
                {
                  id: 20444,
                  name: "rice",
                  localizedName: "rice",
                  image: "uncooked-white-rice.png",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Add the wasabi.",
              ingredients: [
                {
                  id: 11990,
                  name: "wasabi",
                  localizedName: "wasabi",
                  image: "wasabi.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Roll the sushi and cut into slices.",
              ingredients: [
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Serve with salmon caviar, wasabi and soy.",
              ingredients: [
                {
                  id: 15072,
                  name: "salmon caviar",
                  localizedName: "salmon caviar",
                  image: "salmon-caviar.png",
                },
                {
                  id: 11990,
                  name: "wasabi",
                  localizedName: "wasabi",
                  image: "wasabi.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Recipe two: Squeeze the rice into balls and press the prawns, tuna or salmon into the top.",
              ingredients: [
                {
                  id: 15270,
                  name: "shrimp",
                  localizedName: "shrimp",
                  image: "shrimp.png",
                },
                {
                  id: 15076,
                  name: "salmon",
                  localizedName: "salmon",
                  image: "salmon.png",
                },
                {
                  id: 20444,
                  name: "rice",
                  localizedName: "rice",
                  image: "uncooked-white-rice.png",
                },
                {
                  id: 10015121,
                  name: "tuna",
                  localizedName: "tuna",
                  image: "canned-tuna.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/japanese-sushi-648506",
    },
  },
  {
    id: 1095955,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 14,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 76.0,
      healthScore: 37.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 268.59,
      extendedIngredients: [
        {
          id: 4582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vegetable-oil.jpg",
          consistency: "liquid",
          name: "canola oil",
          nameClean: "cooking oil",
          original: "2 tablespoons canola oil",
          originalName: "canola oil",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 10218,
          aisle: "Meat",
          image: "pork-tenderloin-raw.png",
          consistency: "solid",
          name: "pork tenderloins",
          nameClean: "pork tenderloin",
          original: "2 pounds pork tenderloins",
          originalName: "pork tenderloins",
          amount: 2.0,
          unit: "pounds",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 907.185,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "amounts of salt and pepper",
          nameClean: "salt and pepper",
          original: "generous amounts of salt and pepper",
          originalName: "generous amounts of salt and pepper",
          amount: 6.0,
          unit: "servings",
          meta: ["generous"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 6112,
          aisle: "Ethnic Foods;Condiments",
          image: "dark-sauce.jpg",
          consistency: "solid",
          name: "teriyaki sauce",
          nameClean: "teriyaki sauce",
          original: "2 cups teriyaki sauce",
          originalName: "teriyaki sauce",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 12023,
          aisle: "Ethnic Foods;Spices and Seasonings",
          image: "sesame-seeds.png",
          consistency: "solid",
          name: "sesame seeds",
          nameClean: "sesame seeds",
          original: "toasted sesame seeds",
          originalName: "toasted sesame seeds",
          amount: 6.0,
          unit: "servings",
          meta: ["toasted"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11291,
          aisle: "Produce",
          image: "spring-onions.jpg",
          consistency: "solid",
          name: "green onions",
          nameClean: "spring onions",
          original: "2 green onions chopped",
          originalName: "green onions chopped",
          amount: 2.0,
          unit: "",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 10120444,
          aisle: "Pasta and Rice",
          image: "rice-jasmine-cooked.jpg",
          consistency: "solid",
          name: "jasmine rice",
          nameClean: "jasmine rice",
          original: "jasmine rice",
          originalName: "jasmine rice",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11090,
          aisle: "Produce",
          image: "broccoli.jpg",
          consistency: "solid",
          name: "broccoli",
          nameClean: "broccoli",
          original: "broccoli",
          originalName: "broccoli",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
      ],
      id: 1095955,
      title: "Instant Pot Pork Tenderloin Teriyaki",
      readyInMinutes: 40,
      servings: 6,
      sourceUrl:
        "https://www.foodista.com/recipe/QKLKXBFH/instant-pot-pork-tenderloin-teriyaki",
      image: "https://spoonacular.com/recipeImages/1095955-556x370.jpg",
      imageType: "jpg",
      summary:
        'If you want to add more <b>gluten free and dairy free</b> recipes to your recipe box, Instant Pot Pork Tenderloin Teriyaki might be a recipe you should try. For <b>$2.69 per serving</b>, you get a main course that serves 6. One serving contains <b>538 calories</b>, <b>43g of protein</b>, and <b>14g of fat</b>. 1 person were impressed by this recipe. It is a <b>reasonably priced</b> recipe for fans of Japanese food. From preparation to the plate, this recipe takes approximately <b>40 minutes</b>. A mixture of teriyaki sauce, broccoli, sesame seeds, and a handful of other ingredients are all it takes to make this recipe so tasty. It is brought to you by Foodista. With a spoonacular <b>score of 87%</b>, this dish is excellent. Similar recipes are <a href="https://spoonacular.com/recipes/instant-pot-pork-tenderloin-1180769">Instant Pot Pork Tenderloin</a>, <a href="https://spoonacular.com/recipes/instant-pot-pork-tenderloin-recipe-1151190">Instant Pot Pork Tenderloin Recipe</a>, and <a href="https://spoonacular.com/recipes/easy-instant-pot-pork-tenderloin-1116449">Easy Instant Pot Pork Tenderloin</a>.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free"],
      occasions: [],
      winePairing: {
        pairedWines: ["malbec", "pinot noir", "sangiovese"],
        pairingText:
          "Pork Tenderloin on the menu? Try pairing with Malbec, Pinot Noir, and Sangiovese. Pinot noir's light body is great for lean cuts, medium bodied sangiovese complement meaty sauces, stews, and other multi-ingredient dishes, and full-bodied tannic malbec pairs with fatty cuts and barbecue. The Sur de los Andes Malbec with a 4.9 out of 5 star rating seems like a good match. It costs about 10 dollars per bottle.",
        productMatches: [
          {
            id: 452504,
            title: "Sur de los Andes Malbec",
            description:
              "A juicy Malbec with lively acidity backing the raspberry, blackberry and plum notes woven with soft tannins and spice-tinged finish. All the grapes are double sorted upon arrival to the winery. All fermentations take place naturally with native yeasts. Fermentation takes 20 days with 2 days of cold maceration, at temperatures between 24-27 Celsius to achieve the most complexity. The wine then goes through 100% Malolactic Fermentation and is aged in older oak casks.",
            price: "$10.49",
            imageUrl:
              "https://spoonacular.com/productImages/452504-312x231.jpg",
            averageRating: 0.9800000000000001,
            ratingCount: 11.0,
            score: 0.9505882352941177,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fsur-de-los-andes-malbec-2008%2F107947",
          },
        ],
      },
      instructions:
        "<ol><li>Turn your Instant Pot to saute and put the oil in the bottom. </li><li>Once the pan is hot, add the tenderloins (cut in half lengthwise) and lightly brown.</li><li>Once you are finished browning the meat, lay the roasts down in the cooker and pour the teriyaki sauce over the top. If using a particularly thick kind make sure to thin it out a bit with some water so it doesn't burn to the bottom.</li><li>Close and seal the lid and set the pot to manual and 20 minutes of cook time.</li><li>Allow the pot to release pressure naturally, and then remove the lid and slice the meat.</li><li>Serve with jasmine rice and steamed broccoli. </li><li>Garnish with toasted sesame seeds and chopped green onions.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Turn your Instant Pot to saute and put the oil in the bottom. Once the pan is hot, add the tenderloins (cut in half lengthwise) and lightly brown.Once you are finished browning the meat, lay the roasts down in the cooker and pour the teriyaki sauce over the top. If using a particularly thick kind make sure to thin it out a bit with some water so it doesn't burn to the bottom.Close and seal the lid and set the pot to manual and 20 minutes of cook time.Allow the pot to release pressure naturally, and then remove the lid and slice the meat.",
              ingredients: [
                {
                  id: 6112,
                  name: "teriyaki sauce",
                  localizedName: "teriyaki sauce",
                  image: "dark-sauce.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 1065062,
                  name: "meat",
                  localizedName: "meat",
                  image: "whole-chicken.jpg",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 414093,
                  name: "instant pot",
                  localizedName: "instant pot",
                  image: "",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Serve with jasmine rice and steamed broccoli.",
              ingredients: [
                {
                  id: 10120444,
                  name: "jasmine rice",
                  localizedName: "jasmine rice",
                  image: "rice-jasmine-cooked.jpg",
                },
                {
                  id: 11090,
                  name: "broccoli",
                  localizedName: "broccoli",
                  image: "broccoli.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Garnish with toasted sesame seeds and chopped green onions.",
              ingredients: [
                {
                  id: 11291,
                  name: "green onions",
                  localizedName: "green onions",
                  image: "spring-onions.jpg",
                },
                {
                  id: 12023,
                  name: "sesame seeds",
                  localizedName: "sesame seeds",
                  image: "sesame-seeds.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/instant-pot-pork-tenderloin-teriyaki-1095955",
    },
  },
  {
    id: 648460,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 17,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 3,
      spoonacularScore: 75.0,
      healthScore: 29.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 217.45,
      extendedIngredients: [
        {
          id: 11457,
          aisle: "Produce",
          image: "spinach.jpg",
          consistency: "solid",
          name: "baby spinach leaves",
          nameClean: "baby spinach",
          original: "6 cups baby spinach leaves (about 6 oz) rinsed, drained",
          originalName: "cups baby spinach leaves (about rinsed, drained",
          amount: 6.0,
          unit: "oz",
          meta: ["rinsed", "drained"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 5062,
          aisle: "Meat",
          image: "chicken-breasts.png",
          consistency: "solid",
          name: "chicken breast",
          nameClean: "chicken breast",
          original:
            '1/2 pound boned skinned chicken breast rinsed and cut into ¼" strips',
          originalName:
            'boned skinned chicken breast rinsed and cut into ¼" strips',
          amount: 0.5,
          unit: "pound",
          meta: ["rinsed", 'cut into ¼" strips'],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 226.796,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 10220445,
          aisle: "Pasta and Rice",
          image: "cooked-white-rice.png",
          consistency: "solid",
          name: "cooked rice",
          nameClean: "cooked rice",
          original: "6 cups cooked rice",
          originalName: "cooked rice",
          amount: 6.0,
          unit: "cups",
          meta: ["cooked"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 1.42,
              unitShort: "l",
              unitLong: "liters",
            },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "5 large eggs (yolks and whites separated)",
          originalName: "eggs (yolks and whites separated)",
          amount: 5.0,
          unit: "large",
          meta: ["separated", "(yolks and whites )"],
          measures: {
            us: {
              amount: 5.0,
              unitShort: "large",
              unitLong: "larges",
            },
            metric: {
              amount: 5.0,
              unitShort: "large",
              unitLong: "larges",
            },
          },
        },
        {
          id: 6984,
          aisle: "Canned and Jarred",
          image: "chicken-broth.png",
          consistency: "liquid",
          name: "fat-skimmed chicken broth",
          nameClean: "fat free chicken broth",
          original: "1 cup fat-skimmed chicken broth",
          originalName: "fat-skimmed chicken broth",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "fresh ginger",
          nameClean: "ginger",
          original: "2 tablespoons minced fresh ginger",
          originalName: "minced fresh ginger",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["fresh", "minced"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1 onion - (6 oz) peeled, and",
          originalName: "onion - peeled, and",
          amount: 6.0,
          unit: "oz",
          meta: ["peeled"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 10211529,
          aisle: "Produce",
          image: "roma-tomatoes.png",
          consistency: "solid",
          name: "roma tomato",
          nameClean: "italian tomato",
          original: "1/4 cup diced Roma tomato",
          originalName: "diced Roma tomato",
          amount: 0.25,
          unit: "cup",
          meta: ["diced"],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1004582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "salad oil",
          nameClean: "salad oil",
          original: "1 cup salad oil",
          originalName: "salad oil",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 16124,
          aisle: "Ethnic Foods;Condiments",
          image: "soy-sauce.jpg",
          consistency: "liquid",
          name: "soy sauce",
          nameClean: "soy sauce",
          original: "2 tablespoons Soy sauce",
          originalName: "Soy sauce",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "4 tablespoons sugar",
          originalName: "sugar",
          amount: 4.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 4.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
      ],
      id: 648460,
      title: "Japanese Chicken Donburi",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl:
        "http://www.foodista.com/recipe/7F3H56GP/japanese-chicken-donburi",
      image: "https://spoonacular.com/recipeImages/648460-556x370.jpg",
      imageType: "jpg",
      summary:
        'Japanese Chicken Donburi might be just the main course you are searching for. This gluten free and dairy free recipe serves 4 and costs <b>$1.94 per serving</b>. One serving contains <b>536 calories</b>, <b>28g of protein</b>, and <b>8g of fat</b>. If you have roma tomato, sugar, onion, and a few other ingredients on hand, you can make it. To use up the eggs you could follow this main course with the <a href="https://spoonacular.com/recipes/rose-levy-beranbaums-chocolate-tomato-cake-with-mystery-ganache-27408">Rose Levy Beranbaum\'s Chocolate Tomato Cake with Mystery Ganache</a> as a dessert. This recipe is liked by 2 foodies and cooks. All things considered, we decided this recipe <b>deserves a spoonacular score of 76%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/how-to-cook-oyakodon-chicken-and-egg-donburi-478340">How to cook: Oyakodon (chicken and egg donburi)</a>, <a href="https://spoonacular.com/recipes/oyster-donburi-565054">Oyster Donburi</a>, and <a href="https://spoonacular.com/recipes/niratama-donburi-540969">Niratama Donburi</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>In a deep 10-inch or 12-inch frying pan over high heat, stir oil, onion, and ginger until onion is lightly browned, about 2 minutes.</li><li>Add broth, soy sauce, and sugar. Add chicken to pan. Bring to a boil.</li><li>Add spinach, cover, and cook until wilted, about 1 minute. Meanwhile, in a small bowl, beat eggs to blend.</li><li>Reduce heat to low, evenly distribute mixture in pan, and pour in eggs. With a spatula, push vegetables aside slightly so egg mixture can flow down through sauce. Cover and cook just until eggs are softly set, 2 to 2 1/2 minutes.</li><li>Meanwhile, spoon rice into bowls. Top equally with egg-spinach mixture, including juices. Sprinkle with tomato.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a deep 10-inch or 12-inch frying pan over high heat, stir oil, onion, and ginger until onion is lightly browned, about 2 minutes.",
              ingredients: [
                {
                  id: 11216,
                  name: "ginger",
                  localizedName: "ginger",
                  image: "ginger.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 2,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Add broth, soy sauce, and sugar.",
              ingredients: [
                {
                  id: 16124,
                  name: "soy sauce",
                  localizedName: "soy sauce",
                  image: "soy-sauce.jpg",
                },
                {
                  id: 1006615,
                  name: "broth",
                  localizedName: "broth",
                  image: "chicken-broth.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Add chicken to pan. Bring to a boil.",
              ingredients: [
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 4,
              step: "Add spinach, cover, and cook until wilted, about 1 minute. Meanwhile, in a small bowl, beat eggs to blend.Reduce heat to low, evenly distribute mixture in pan, and pour in eggs. With a spatula, push vegetables aside slightly so egg mixture can flow down through sauce. Cover and cook just until eggs are softly set, 2 to 2 1/2 minutes.Meanwhile, spoon rice into bowls. Top equally with egg-spinach mixture, including juices.",
              ingredients: [
                {
                  id: 11583,
                  name: "vegetable",
                  localizedName: "vegetable",
                  image: "mixed-vegetables.png",
                },
                {
                  id: 10011457,
                  name: "spinach",
                  localizedName: "spinach",
                  image: "spinach.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
                {
                  id: 20444,
                  name: "rice",
                  localizedName: "rice",
                  image: "uncooked-white-rice.png",
                },
              ],
              equipment: [
                {
                  id: 404642,
                  name: "spatula",
                  localizedName: "spatula",
                  image: "spatula-or-turner.jpg",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 3,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Sprinkle with tomato.",
              ingredients: [
                {
                  id: 11529,
                  name: "tomato",
                  localizedName: "tomato",
                  image: "tomato.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/japanese-chicken-donburi-648460",
    },
  },
  {
    id: 637908,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 15,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 74.0,
      healthScore: 33.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 346.71,
      extendedIngredients: [
        {
          id: 10020420,
          aisle: "Pasta and Rice",
          image: "angelhair.jpg",
          consistency: "solid",
          name: "angel hair pasta",
          nameClean: "angel hair pasta",
          original:
            "6 oz of fresh angel hair pasta, cut in half to approximately 8 inch lengths",
          originalName:
            "fresh angel hair pasta, cut in half to approximately 8 inch lengths",
          amount: 6.0,
          unit: "oz",
          meta: ["fresh", "cut in half to approximately 8 inch lengths"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11124,
          aisle: "Produce",
          image: "sliced-carrot.png",
          consistency: "solid",
          name: "carrot",
          nameClean: "carrot",
          original: "1 baby carrot, skinned and shredded",
          originalName: "baby carrot, skinned and shredded",
          amount: 1.0,
          unit: "",
          meta: ["shredded"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "2 hard boiled eggs, shelled and halved",
          originalName: "hard boiled eggs, shelled and halved",
          amount: 2.0,
          unit: "",
          meta: ["hard", "boiled", "shelled", "halved"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger root",
          nameClean: "ginger",
          original: "1 piece of ginger root, sliced thin",
          originalName: "ginger root, sliced thin",
          amount: 1.0,
          unit: "piece",
          meta: ["sliced", "thin"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 6970,
          aisle: "Canned and Jarred",
          image: "chicken-broth.png",
          consistency: "liquid",
          name: "low-salt chicken broth",
          nameClean: "low sodium chicken broth",
          original: "4 cup organic, low salt chicken stock",
          originalName: "organic, low salt chicken stock",
          amount: 4.0,
          unit: "cup",
          meta: ["organic"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 946.352,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 16112,
          aisle: "Ethnic Foods",
          image: "miso.jpg",
          consistency: "solid",
          name: "Miso Soybean Paste",
          nameClean: "miso",
          original: "3 T organic white miso paste",
          originalName: "organic white miso paste",
          amount: 3.0,
          unit: "T",
          meta: ["white", "organic"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11446,
          aisle: "Ethnic Foods",
          image: "nori.jpg",
          consistency: "solid",
          name: "nori",
          nameClean: "nori",
          original: "2 sheets nori",
          originalName: "nori",
          amount: 2.0,
          unit: "sheets",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "sheets",
              unitLong: "sheets",
            },
            metric: {
              amount: 2.0,
              unitShort: "sheets",
              unitLong: "sheets",
            },
          },
        },
        {
          id: 10011282,
          aisle: "Produce",
          image: "red-onion.png",
          consistency: "solid",
          name: "red onion",
          nameClean: "red onion",
          original: "1 slice of red onion 1/4” thick cut in half crosswise",
          originalName: "red onion 1/4” thick cut in half crosswise",
          amount: 1.0,
          unit: "slice",
          meta: ["thick cut", "red"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "slice",
              unitLong: "slice",
            },
            metric: {
              amount: 1.0,
              unitShort: "slice",
              unitLong: "slice",
            },
          },
        },
        {
          id: 12023,
          aisle: "Ethnic Foods;Spices and Seasonings",
          image: "sesame-seeds.png",
          consistency: "solid",
          name: "sesame seeds",
          nameClean: "sesame seeds",
          original: "1 T sesame seeds, if desired",
          originalName: "sesame seeds, if desired",
          amount: 1.0,
          unit: "T",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 1055062,
          aisle: "Meat",
          image: "chicken-breasts.png",
          consistency: "solid",
          name: "skinless boneless chicken breast",
          nameClean: "boneless skinless chicken breast",
          original: "1 boneless, skinless organic chicken breast",
          originalName: "boneless, skinless organic chicken breast",
          amount: 1.0,
          unit: "",
          meta: ["boneless", "skinless", "organic"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11291,
          aisle: "Produce",
          image: "spring-onions.jpg",
          consistency: "solid",
          name: "spring onion",
          nameClean: "spring onions",
          original:
            "1 organic spring onion, cut into small pieces crosswise ( substitute is 2 green onions)",
          originalName:
            "organic spring onion, cut into small pieces crosswise ( substitute is 2 green onions)",
          amount: 1.0,
          unit: "",
          meta: [
            "organic",
            "cut into small pieces crosswise ( substitute is 2 green onions)",
          ],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
      ],
      id: 637908,
      title: "Chicken and Miso Ramen Noodle Soup",
      readyInMinutes: 30,
      servings: 2,
      sourceUrl:
        "http://www.foodista.com/recipe/LSGT2GRK/chicken-and-miso-ramen-noodle-soup",
      image: "https://spoonacular.com/recipeImages/637908-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe Chicken and Miso Ramen Noodle Soup is ready <b>in approximately 30 minutes</b> and is definitely an awesome <b>dairy free</b> option for lovers of Japanese food. One serving contains <b>616 calories</b>, <b>43g of protein</b>, and <b>14g of fat</b>. For <b>$3.46 per serving</b>, this recipe <b>covers 34%</b> of your daily requirements of vitamins and minerals. Not a lot of people made this recipe, and 1 would say it hit the spot. It works well as a rather expensive main course for <b>Autumn</b>. If you have chicken breast, ginger root, spring onion, and a few other ingredients on hand, you can make it. To use up the sesame seeds you could follow this main course with the <a href="https://spoonacular.com/recipes/sesame-banana-bread-80347">Sesame Banana Bread</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 76%</b>. This score is pretty good. Try <a href="https://spoonacular.com/recipes/ramen-chicken-noodle-soup-822463">Ramen Chicken Noodle Soup</a>, <a href="https://spoonacular.com/recipes/cooking-school-miso-ramen-with-miso-glazed-chicken-enoki-and-shimeji-mushrooms-629499">Cooking School: Miso Ramen with Miso Glazed Chicken, Enoki and Shimeji Mushrooms</a>, and <a href="https://spoonacular.com/recipes/thai-peanut-chicken-and-ramen-noodle-soup-549759">Thai Peanut Chicken and Ramen Noodle Soup</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free"],
      occasions: ["fall", "winter"],
      winePairing: {},
      instructions:
        "<ol><li>Hard boil the eggs for about 12 minutes then cool in ice water. Then reserve at room temperature.</li><li>Grill or saute the chicken for about 8 minutes each side or until internal temperature is 155-160*F. Then reserve in a warming oven with the bowls.</li><li>Wash, dry and cut the vegetables to size while the cooking is going on.</li><li>Soup: Pour the chicken stock into a suitable pot.</li><li>Add the miso and sliced ginger and stir to mix while bringing to a simmer.</li><li>Simmer for 10 minutes, stirring occasionally.</li><li>Place the fresh angel hair pasta noodles in the bottom of the bowls uncooked; then while the soup is still hot, pour it over the noodles to a depth that just covers them.</li><li>Arrange the chicken and vegetables carefully on top of the noodles or beside the noodles so that everything is level with the top of the soup and the arrangement is attractive.</li><li>Carefully slide the nori into the edge of the soup only partially submerging it.</li><li>Sprinkle the sesame seeds on top if desired and serve with soy or tamari sauce.</li></ol>",
      analyzedInstructions: [
        {
          name: "Hard boil the eggs for about 12 minutes then cool in ice water. Then reserve at room temperature.Grill or saute the chicken for about 8 minutes each side or until internal temperature is 155-160*F. Then reserve in a warming oven with the bowls.Wash, dry and cut the vegetables to size while the cooking is going on.Soup",
          steps: [
            {
              number: 1,
              step: "Pour the chicken stock into a suitable pot.",
              ingredients: [
                {
                  id: 6172,
                  name: "chicken stock",
                  localizedName: "chicken stock",
                  image: "chicken-broth.png",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add the miso and sliced ginger and stir to mix while bringing to a simmer.Simmer for 10 minutes, stirring occasionally.",
              ingredients: [
                {
                  id: 11216,
                  name: "ginger",
                  localizedName: "ginger",
                  image: "ginger.png",
                },
                {
                  id: 16112,
                  name: "miso",
                  localizedName: "miso",
                  image: "miso.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Place the fresh angel hair pasta noodles in the bottom of the bowls uncooked; then while the soup is still hot, pour it over the noodles to a depth that just covers them.Arrange the chicken and vegetables carefully on top of the noodles or beside the noodles so that everything is level with the top of the soup and the arrangement is attractive.Carefully slide the nori into the edge of the soup only partially submerging it.",
              ingredients: [
                {
                  id: 10020420,
                  name: "angel hair pasta",
                  localizedName: "angel hair pasta",
                  image: "angelhair.jpg",
                },
                {
                  id: 11583,
                  name: "vegetable",
                  localizedName: "vegetable",
                  image: "mixed-vegetables.png",
                },
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
                {
                  id: 20420,
                  name: "pasta",
                  localizedName: "pasta",
                  image: "fusilli.jpg",
                },
                {
                  id: 11446,
                  name: "nori",
                  localizedName: "nori",
                  image: "nori.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Sprinkle the sesame seeds on top if desired and serve with soy or tamari sauce.",
              ingredients: [
                {
                  id: 12023,
                  name: "sesame seeds",
                  localizedName: "sesame seeds",
                  image: "sesame-seeds.png",
                },
                {
                  id: 10116124,
                  name: "tamari",
                  localizedName: "tamari",
                  image: "soy-sauce.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chicken-and-miso-ramen-noodle-soup-637908",
    },
  },

  {
    id: 633841,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 33,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 2,
      spoonacularScore: 74.0,
      healthScore: 30.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 468.48,
      extendedIngredients: [
        {
          id: 5066,
          aisle: "Meat",
          image: "chicken-drumsticks.jpg",
          consistency: "solid",
          name: "chicken drumsticks",
          nameClean: "chicken drumsticks",
          original: "6 chicken drumsticks",
          originalName: "chicken drumsticks",
          amount: 6.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "2 cloves of garlic diced",
          originalName: "garlic diced",
          amount: 2.0,
          unit: "cloves",
          meta: ["diced"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cloves",
              unitLong: "cloves",
            },
            metric: {
              amount: 2.0,
              unitShort: "cloves",
              unitLong: "cloves",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger",
          nameClean: "ginger",
          original: "1 tablespoon of shredded ginger",
          originalName: "shredded ginger",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["shredded"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 19296,
          aisle: "Nut butters, Jams, and Honey",
          image: "honey.png",
          consistency: "liquid",
          name: "honey",
          nameClean: "honey",
          original: "1 teaspoon of honey",
          originalName: "honey",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1 onion, sliced",
          originalName: "onion, sliced",
          amount: 1.0,
          unit: "",
          meta: ["sliced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "Salt, pepper, garlic,",
          originalName: "Salt, pepper, garlic",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 6112,
          aisle: "Ethnic Foods;Condiments",
          image: "dark-sauce.jpg",
          consistency: "solid",
          name: "teriyaki sauce",
          nameClean: "teriyaki sauce",
          original: "1 cup of teriyaki sauce",
          originalName: "teriyaki sauce",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 4513,
          aisle: null,
          image: null,
          consistency: null,
          name: "vegetable oil",
          nameClean: null,
          original: "1 teaspoon of vegetable oil",
          originalName: "vegetable oil",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
      ],
      id: 633841,
      title: "Baked Teriyaki Chicken Drumsticks",
      readyInMinutes: 45,
      servings: 1,
      sourceUrl:
        "http://www.foodista.com/recipe/P2H7T2SX/baked-teriyaki-chicken-drumsticks",
      image: "https://spoonacular.com/recipeImages/633841-556x370.jpg",
      imageType: "jpg",
      summary:
        'Baked Teriyaki Chicken Drumsticks might be just the <b>Japanese</b> recipe you are searching for. This recipe makes 1 servings with <b>1093 calories</b>, <b>99g of protein</b>, and <b>46g of fat</b> each. For <b>$4.68 per serving</b>, this recipe <b>covers 42%</b> of your daily requirements of vitamins and minerals. It works well as a rather expensive main course. 2 people have made this recipe and would make it again. Head to the store and pick up chicken drumsticks, vegetable oil, teriyaki sauce, and a few other things to make it today. To use up the honey you could follow this main course with the <a href="https://spoonacular.com/recipes/honey-gingerbread-133051">Honey Gingerbread</a> as a dessert. It is a good option if you\'re following a <b>gluten free and dairy free</b> diet. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 76%</b>. This score is solid. Try <a href="https://spoonacular.com/recipes/baked-chicken-drumsticks-704026">Baked Chicken Drumsticks</a>, <a href="https://spoonacular.com/recipes/baked-chicken-drumsticks-112268">Baked Chicken Drumsticks</a>, and <a href="https://spoonacular.com/recipes/baked-chicken-drumsticks-551905">Baked Chicken Drumsticks</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>In a large bowl, mix teriyaki sauce, salt vegetable oil, honey, and ginger.  Add the chicken to the marinade.  Let the chicken marinade for about 4-5 hours.</li><li>Preheat oven to 450 degrees.  Add the sliced onions and diced garlic on the baking pan.  Lay the chicken on top of the onions and garlic.  Bake the chicken for 30 minutes turning once until cooked.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a large bowl, mix teriyaki sauce, salt vegetable oil, honey, and ginger.",
              ingredients: [
                {
                  id: 6112,
                  name: "teriyaki sauce",
                  localizedName: "teriyaki sauce",
                  image: "dark-sauce.jpg",
                },
                {
                  id: 4669,
                  name: "vegetable oil",
                  localizedName: "vegetable oil",
                  image: "vegetable-oil.jpg",
                },
                {
                  id: 11216,
                  name: "ginger",
                  localizedName: "ginger",
                  image: "ginger.png",
                },
                {
                  id: 19296,
                  name: "honey",
                  localizedName: "honey",
                  image: "honey.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add the chicken to the marinade.",
              ingredients: [
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Let the chicken marinade for about 4-5 hours.Preheat oven to 450 degrees.",
              ingredients: [
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 300,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Add the sliced onions and diced garlic on the baking pan.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [
                {
                  id: 404646,
                  name: "baking pan",
                  localizedName: "baking pan",
                  image: "roasting-pan.jpg",
                },
              ],
            },
            {
              number: 5,
              step: "Lay the chicken on top of the onions and garlic.",
              ingredients: [
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Bake the chicken for 30 minutes turning once until cooked.",
              ingredients: [
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 30,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/baked-teriyaki-chicken-drumsticks-633841",
    },
  },

  {
    id: 638382,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 19,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 74.0,
      healthScore: 35.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 721.54,
      extendedIngredients: [
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "2 TBSP Brown Sugar",
          originalName: "Brown Sugar",
          amount: 2.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 20027,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "cornstarch",
          nameClean: "corn starch",
          original: "1/2 TBSP cornstarch",
          originalName: "cornstarch",
          amount: 0.5,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 0.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "2 TBSP Garlic, minced",
          originalName: "Garlic, minced",
          amount: 2.0,
          unit: "TBSP",
          meta: ["minced"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ginger",
          nameClean: "ginger",
          original: "2 TBSP Ginger, minced",
          originalName: "Ginger, minced",
          amount: 2.0,
          unit: "TBSP",
          meta: ["minced"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11291,
          aisle: "Produce",
          image: "spring-onions.jpg",
          consistency: "solid",
          name: "green onion",
          nameClean: "spring onions",
          original: "1 Green onion, sliced",
          originalName: "Green onion, sliced",
          amount: 1.0,
          unit: "",
          meta: ["sliced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "lemon juice",
          nameClean: "lemon juice",
          original: "2 TBSP Lemon Juice",
          originalName: "Lemon Juice",
          amount: 2.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 16424,
          aisle: "Ethnic Foods;Condiments",
          image: "soy-sauce.jpg",
          consistency: "liquid",
          name: "low sodium soy sauce",
          nameClean: "lower sodium soy sauce",
          original: "1/2 cup low sodium soy sauce",
          originalName: "low sodium soy sauce",
          amount: 0.5,
          unit: "cup",
          meta: ["low sodium"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 93830,
          aisle: "Ethnic Foods",
          image: "mirin.jpg",
          consistency: "solid",
          name: "mirin",
          nameClean: "mirin",
          original: "2 TBSP Mirin",
          originalName: "Mirin",
          amount: 2.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 4058,
          aisle: "Ethnic Foods",
          image: "sesame-oil.png",
          consistency: "liquid",
          name: "sesame oil",
          nameClean: "sesame oil",
          original: "1 TBSP sesame oil",
          originalName: "sesame oil",
          amount: 1.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 12023,
          aisle: "Ethnic Foods;Spices and Seasonings",
          image: "sesame-seeds.png",
          consistency: "solid",
          name: "sesame seeds",
          nameClean: "sesame seeds",
          original: "2 TBSP sesame seeds",
          originalName: "sesame seeds",
          amount: 2.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11238,
          aisle: "Produce",
          image: "shiitake-mushrooms.png",
          consistency: "solid",
          name: "shiitake mushrooms",
          nameClean: "shiitake mushrooms",
          original: "6 oz shiitake mushrooms",
          originalName: "shiitake mushrooms",
          amount: 6.0,
          unit: "oz",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 1055062,
          aisle: "Meat",
          image: "chicken-breasts.png",
          consistency: "solid",
          name: "skinless boneless chicken breasts",
          nameClean: "boneless skinless chicken breast",
          original: "2 Boneless Skinless Chicken Breasts",
          originalName: "Boneless Skinless Chicken Breasts",
          amount: 2.0,
          unit: "",
          meta: ["boneless", "skinless"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 20114,
          aisle: "Pasta and Rice;Ethnic Foods",
          image: "uncooked-soba-noodles.png",
          consistency: "solid",
          name: "soba noodles",
          nameClean: "soba noodles",
          original: "6 oz soba noodles",
          originalName: "soba noodles",
          amount: 6.0,
          unit: "oz",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 1016168,
          aisle: "Condiments",
          image: "hot-sauce-or-tabasco.png",
          consistency: "liquid",
          name: "sriracha",
          nameClean: "sriracha",
          original: "2 TBSP Sriracha",
          originalName: "Sriracha",
          amount: 2.0,
          unit: "TBSP",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
      ],
      id: 638382,
      title: "Chicken Teriyaki with Soba Noodles",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl:
        "http://www.foodista.com/recipe/2KWF3F3B/chicken-teriyaki-with-soba-noodles",
      image: "https://spoonacular.com/recipeImages/638382-556x370.jpg",
      imageType: "jpg",
      summary:
        'Chicken Teriyaki with Soba Noodles might be just the main course you are searching for. This recipe serves 2 and costs $7.22 per serving. One serving contains <b>693 calories</b>, <b>44g of protein</b>, and <b>16g of fat</b>. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. Head to the store and pick up soy sauce, cornstarch, shiitake mushrooms, and a few other things to make it today. Not a lot of people made this recipe, and 1 would say it hit the spot. This recipe is typical of Japanese cuisine. It is a good option if you\'re following a <b>dairy free</b> diet. All things considered, we decided this recipe <b>deserves a spoonacular score of 75%</b>. This score is solid. Try <a href="https://spoonacular.com/recipes/wildwood-sproutofu-teriyaki-stir-fry-over-soba-noodles-506716">Wildwood SprouTofu Teriyaki Stir-Fry over Soba Noodles</a>, <a href="https://spoonacular.com/recipes/teriyaki-soba-noodles-with-tofu-and-stir-fried-spinach-761399">Teriyaki Soba Noodles with Tofu and Stir-fried Spinach</a>, and <a href="https://spoonacular.com/recipes/cold-soba-noodles-with-tsuyu-dipping-sauce-zaru-soba-41492">Cold Soba Noodles With Tsuyu Dipping Sauce (zaru Soba)</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>1. Preheat oven to 400 degrees Fahrenheit. Slice shiitakes into bite sized pieces. Place chicken breasts in a 9 by 13 glass dish.</li><li>2. Make sauce: In a small bowel, add all the ingredients and whisk together.</li><li>3. Pour sauce over chicken breasts. Place in oven and cook for 20 min. Take out of oven and add shiitakes. Toss shiitakes with the sauce that is around the chicken, flip chicken. Place in oven for 10 minutes more.  Once done,take out of oven.Let rest 5 minutes before slicing chicken into bite sized pieces.</li><li>4. Meanwhile, add water to a medium pot. Once brought to a boil, add soba noodles and cook for 7 minutes till done. Drain and rinse under cold water and add back to pot. Add shitakes and all of sauce to the soba noodles. Toss together.</li><li>5. Add 1/2 the soba noodles and shitakes to each plate. Add 1 sliced chicken breast to each plate. Garnish with green onion and sesame seeds. Serve immediately.</li><li>ENJOY!</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 400 degrees Fahrenheit. Slice shiitakes into bite sized pieces.",
              ingredients: [
                {
                  id: 11238,
                  name: "shiitake mushrooms",
                  localizedName: "shiitake mushrooms",
                  image: "shiitake-mushrooms.png",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: {
                    number: 400.0,
                    unit: "Fahrenheit",
                  },
                },
              ],
            },
            {
              number: 2,
              step: "Place chicken breasts in a 9 by 13 glass dish.",
              ingredients: [
                {
                  id: 5062,
                  name: "chicken breast",
                  localizedName: "chicken breast",
                  image: "chicken-breasts.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Make sauce: In a small bowel, add all the ingredients and whisk together.",
              ingredients: [
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 4,
              step: "Pour sauce over chicken breasts.",
              ingredients: [
                {
                  id: 5062,
                  name: "chicken breast",
                  localizedName: "chicken breast",
                  image: "chicken-breasts.png",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Place in oven and cook for 20 min. Take out of oven and add shiitakes. Toss shiitakes with the sauce that is around the chicken, flip chicken.",
              ingredients: [
                {
                  id: 11238,
                  name: "shiitake mushrooms",
                  localizedName: "shiitake mushrooms",
                  image: "shiitake-mushrooms.png",
                },
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Place in oven for 10 minutes more.  Once done,take out of oven.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Let rest 5 minutes before slicing chicken into bite sized pieces.",
              ingredients: [
                {
                  id: 5006,
                  name: "whole chicken",
                  localizedName: "whole chicken",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 8,
              step: "Meanwhile, add water to a medium pot. Once brought to a boil, add soba noodles and cook for 7 minutes till done.",
              ingredients: [
                {
                  id: 20114,
                  name: "soba noodles",
                  localizedName: "soba noodles",
                  image: "uncooked-soba-noodles.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 7,
                unit: "minutes",
              },
            },
            {
              number: 9,
              step: "Drain and rinse under cold water and add back to pot.",
              ingredients: [
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
            },
            {
              number: 10,
              step: "Add shitakes and all of sauce to the soba noodles. Toss together.",
              ingredients: [
                {
                  id: 20114,
                  name: "soba noodles",
                  localizedName: "soba noodles",
                  image: "uncooked-soba-noodles.png",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [],
            },
            {
              number: 11,
              step: "Add 1/2 the soba noodles and shitakes to each plate.",
              ingredients: [
                {
                  id: 20114,
                  name: "soba noodles",
                  localizedName: "soba noodles",
                  image: "uncooked-soba-noodles.png",
                },
              ],
              equipment: [],
            },
            {
              number: 12,
              step: "Add 1 sliced chicken breast to each plate.",
              ingredients: [
                {
                  id: 7961,
                  name: "sliced chicken breast",
                  localizedName: "sliced chicken breast",
                  image: "deli-turkey.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 13,
              step: "Garnish with green onion and sesame seeds.",
              ingredients: [
                {
                  id: 12023,
                  name: "sesame seeds",
                  localizedName: "sesame seeds",
                  image: "sesame-seeds.png",
                },
                {
                  id: 11291,
                  name: "green onions",
                  localizedName: "green onions",
                  image: "spring-onions.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 14,
              step: "Serve immediately.ENJOY!",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chicken-teriyaki-with-soba-noodles-638382",
    },
  },
  {
    id: 648500,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 3,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 67.0,
      healthScore: 24.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 135.38,
      extendedIngredients: [
        {
          id: 23584,
          aisle: "Meat",
          image: "top-sirloin-steak.jpg",
          consistency: "solid",
          name: "beef top sirloin steak",
          nameClean: "top sirloin steak",
          original:
            "1 pound well-trimmed beef top sirloin 3 cups sliced napa cabbage",
          originalName:
            "well-trimmed beef top sirloin 3 cups sliced napa cabbage",
          amount: 1.0,
          unit: "pound",
          meta: ["sliced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "lb",
              unitLong: "pound",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11124,
          aisle: "Produce",
          image: "sliced-carrot.png",
          consistency: "solid",
          name: "carrots",
          nameClean: "carrot",
          original: "1/2 cup thin diagonally sliced carrots",
          originalName: "thin diagonally sliced carrots",
          amount: 0.5,
          unit: "cup",
          meta: ["diagonally sliced", "thin"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 10220445,
          aisle: "Pasta and Rice",
          image: "cooked-white-rice.png",
          consistency: "solid",
          name: "cooked rice",
          nameClean: "cooked rice",
          original: "1 cup cooked rice",
          originalName: "cooked rice",
          amount: 1.0,
          unit: "cup",
          meta: ["cooked"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11206,
          aisle: "Produce",
          image: "cucumber.jpg",
          consistency: "solid",
          name: "cucumber",
          nameClean: "cucumber",
          original: "1/2 cup thin sliced cucumber",
          originalName: "thin sliced cucumber",
          amount: 0.5,
          unit: "cup",
          meta: ["sliced", "thin"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 10114106,
          aisle: "Alcoholic Beverages",
          image: "dry-sherry.png",
          consistency: "liquid",
          name: "dry sherry",
          nameClean: "dry sherry",
          original: "3 tablespoons dry sherry",
          originalName: "dry sherry",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["dry"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11216,
          aisle: "Produce;Ethnic Foods;Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "fresh ginger",
          nameClean: "ginger",
          original: "1/2 teaspoon grated fresh ginger",
          originalName: "grated fresh ginger",
          amount: 0.5,
          unit: "teaspoon",
          meta: ["fresh", "grated"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 11291,
          aisle: "Produce",
          image: "spring-onions.jpg",
          consistency: "solid",
          name: "green onion",
          nameClean: "spring onions",
          original: "1 green onion, sliced diagonally (not to be cooked)",
          originalName: "green onion, sliced diagonally (not to be cooked)",
          amount: 1.0,
          unit: "",
          meta: ["cooked", "sliced", "(not to be )"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 6175,
          aisle: "Ethnic Foods",
          image: "dark-sauce.jpg",
          consistency: "solid",
          name: "hoisin sauce",
          nameClean: "hoisin sauce",
          original: "2 tablespoons hoisin sauce",
          originalName: "hoisin sauce",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 10216124,
          aisle: "Ethnic Foods;Condiments",
          image: "soy-sauce.jpg",
          consistency: "liquid",
          name: "light soy sauce",
          nameClean: "light soy sauce",
          original: "3 tablespoons light soy sauce",
          originalName: "light soy sauce",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["light"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 4058,
          aisle: "Ethnic Foods",
          image: "sesame-oil.png",
          consistency: "liquid",
          name: "oriental sesame oil",
          nameClean: "sesame oil",
          original: "1 tablespoon Oriental dark roasted sesame oil",
          originalName: "Oriental dark roasted sesame oil",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["dark"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 11300,
          aisle: "Produce",
          image: "snow-peas.jpg",
          consistency: "solid",
          name: "pea pods",
          nameClean: "snow peas",
          original: "24 pea pods, blanched",
          originalName: "pea pods, blanched",
          amount: 24.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 24.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 24.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11429,
          aisle: "Produce",
          image: "radishes.jpg",
          consistency: "solid",
          name: "radishes",
          nameClean: "radish",
          original: "1/2 cup thin sliced radishes",
          originalName: "thin sliced radishes",
          amount: 0.5,
          unit: "cup",
          meta: ["sliced", "thin"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1022053,
          aisle: "Ethnic Foods;Oil, Vinegar, Salad Dressing",
          image: "rice-vinegar.png",
          consistency: "liquid",
          name: "rice wine vinegar",
          nameClean: "rice vinegar",
          original: "3 tablespoons rice wine vinegar",
          originalName: "rice wine vinegar",
          amount: 3.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 10111251,
          aisle: "Produce",
          image: "romaine.jpg",
          consistency: "solid",
          name: "romaine lettuce",
          nameClean: "romaine",
          original: "3 cups romaine lettuce, cut ¼ inch",
          originalName: "romaine lettuce, cut ¼ inch",
          amount: 3.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 709.764,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "1 tablespoon sugar",
          originalName: "sugar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "3 tablespoons water",
          originalName: "water",
          amount: 3.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
      ],
      id: 648500,
      title: "Japanese Steak Salad",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl: "http://www.foodista.com/recipe/48CSHJT8/japanese-steak-salad",
      image: "https://spoonacular.com/recipeImages/648500-556x370.jpg",
      imageType: "jpg",
      summary:
        'Japanese Steak Salad might be just the <b>Japanese</b> recipe you are searching for. This recipe makes 8 servings with <b>148 calories</b>, <b>15g of protein</b>, and <b>4g of fat</b> each. For <b>$1.35 per serving</b>, this recipe <b>covers 12%</b> of your daily requirements of vitamins and minerals. <b>valentin day</b> will be even more special with this recipe. It works well as a main course. From preparation to the plate, this recipe takes about <b>45 minutes</b>. Only a few people made this recipe, and 1 would say it hit the spot. It is a good option if you\'re following a <b>gluten free and dairy free</b> diet. A mixture of pea pods, water, oriental roasted sesame oil, and a handful of other ingredients are all it takes to make this recipe so flavorful. To use up the cooked rice you could follow this main course with the <a href="https://spoonacular.com/recipes/breakfast-rice-pudding-547155">Breakfast Rice Pudding</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 69%</b>. This score is solid. Try <a href="https://spoonacular.com/recipes/japanese-steak-salad-395900">Japanese Steak Salad</a>, <a href="https://spoonacular.com/recipes/japanese-steakhouse-ginger-salad-dressing-copycat-shogun-steak-94890">Japanese Steakhouse Ginger Salad Dressing CopyCat Shogun Steak</a>, and <a href="https://spoonacular.com/recipes/japanese-style-flatiron-steak-81369">Japanese-style Flatiron Steak</a> for similar recipes.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["salad"],
      diets: ["gluten free", "dairy free"],
      occasions: ["valentine's day", "father's day"],
      winePairing: {
        pairedWines: ["merlot", "cabernet sauvignon", "pinot noir"],
        pairingText:
          "Merlot, Cabernet Sauvignon, and Pinot Noir are great choices for Steak. After all, beef and red wine are a classic combination. Generally, leaner steaks go well with light or medium-bodied reds, such as pinot noir or merlot, while fattier steaks can handle a bold red, such as cabernet sauvingnon. The Nickel & Nickel Harris Vineyard Merlot with a 4.2 out of 5 star rating seems like a good match. It costs about 40 dollars per bottle.",
        productMatches: [
          {
            id: 442492,
            title: "Nickel & Nickel Harris Vineyard Merlot",
            description:
              "Bright red fruits, candied blueberry, Santa Rosa plum and menthol aromas all blend together to intoxicate the nose as the 2016 Harris Vineyard Merlot wafts from the glass. On the palate, a juicy and fruity entry is supported by chewy tannins and a balancing acidity, creating lush layers that coat the tongue and produce a soft, elegant finish.",
            price: "$39.99",
            imageUrl:
              "https://spoonacular.com/productImages/442492-312x231.jpg",
            averageRating: 0.8400000000000001,
            ratingCount: 5.0,
            score: 0.7775000000000001,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fnickel-and-nickel-harris-vineyard-merlot-2010%2F124551",
          },
        ],
      },
      instructions:
        "<ol><li>Prepare Sesame Marinade and Dressing. Place beef top sirloin steak in plastic bag; add reserved marinade, turning to coat. Close bag securely and marinate in refrigerator 2 hours, turning once. Remove from marinade; place on rack in broiler pan so surface of meat is 3 to 4 inches from heat. Broil 14 to 16 minutes to doneness desired (rare to medium-rare), turning once. Let stand 5 minutes. Carve steak into thin slices.</li><li>Meanwhile, combine napa cabbage, romaine, carrots and radishes; place an equal amount of each on 4 individual plates. Arrange an equal number of cucumber slices in circle at top of salad greens on each plate. Mound 1/4 cup rice on each cucumber circle. Fan pea pods around both sides of rice. Arrange steak slices as spokes on salad greens, radiating down from rice. Serve dressing with salad. Makes 4 servings.</li><li>Combine dry sherry, soy sauce, vinegar, hoisin sauce and ginger; mix well. Divide mixture in half; reserve half for steak marinade. To prepare dressing, combine remaining mixture with water, green onion, sugar and oil; mix well. Yield: 1/3 cup marinade; 3/4 cup dressing.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Prepare Sesame Marinade and Dressing.",
              ingredients: [
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
                {
                  id: 12023,
                  name: "sesame seeds",
                  localizedName: "sesame seeds",
                  image: "sesame-seeds.png",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Place beef top sirloin steak in plastic bag; add reserved marinade, turning to coat. Close bag securely and marinate in refrigerator 2 hours, turning once.",
              ingredients: [
                {
                  id: 23584,
                  name: "top sirloin steak",
                  localizedName: "top sirloin steak",
                  image: "top-sirloin-steak.jpg",
                },
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
              ],
              equipment: [
                {
                  id: 221671,
                  name: "ziploc bags",
                  localizedName: "ziploc bags",
                  image: "plastic-bag.jpg",
                },
              ],
              length: {
                number: 120,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Remove from marinade; place on rack in broiler pan so surface of meat is 3 to 4 inches from heat. Broil 14 to 16 minutes to doneness desired (rare to medium-rare), turning once.",
              ingredients: [
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
                {
                  id: 1065062,
                  name: "meat",
                  localizedName: "meat",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [
                {
                  id: 404698,
                  name: "broiler pan",
                  localizedName: "broiler pan",
                  image: "broiler-pan.jpg",
                },
              ],
              length: {
                number: 14,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Let stand 5 minutes. Carve steak into thin slices.Meanwhile, combine napa cabbage, romaine, carrots and radishes; place an equal amount of each on 4 individual plates. Arrange an equal number of cucumber slices in circle at top of salad greens on each plate. Mound 1/4 cup rice on each cucumber circle. Fan pea pods around both sides of rice. Arrange steak slices as spokes on salad greens, radiating down from rice.",
              ingredients: [
                {
                  id: 11119,
                  name: "napa cabbage",
                  localizedName: "napa cabbage",
                  image: "napa-cabbage.jpg",
                },
                {
                  id: 21052,
                  name: "greens",
                  localizedName: "greens",
                  image: "mixed-greens-or-mesclun.jpg",
                },
                {
                  id: 11206,
                  name: "cucumber",
                  localizedName: "cucumber",
                  image: "cucumber.jpg",
                },
                {
                  id: 11300,
                  name: "snow peas",
                  localizedName: "snow peas",
                  image: "snow-peas.jpg",
                },
                {
                  id: 11429,
                  name: "radish",
                  localizedName: "radish",
                  image: "radishes.jpg",
                },
                {
                  id: 11124,
                  name: "carrot",
                  localizedName: "carrot",
                  image: "sliced-carrot.png",
                },
                {
                  id: 10111251,
                  name: "romaine",
                  localizedName: "romaine",
                  image: "romaine",
                },
                {
                  id: 23232,
                  name: "steak",
                  localizedName: "steak",
                  image: "ribeye-raw.jpg",
                },
                {
                  id: 20444,
                  name: "rice",
                  localizedName: "rice",
                  image: "uncooked-white-rice.png",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Serve dressing with salad. Makes 4 servings.",
              ingredients: [],
              equipment: [],
            },
            {
              number: 6,
              step: "Combine dry sherry, soy sauce, vinegar, hoisin sauce and ginger; mix well. Divide mixture in half; reserve half for steak marinade. To prepare dressing, combine remaining mixture with water, green onion, sugar and oil; mix well.",
              ingredients: [
                {
                  id: 6175,
                  name: "hoisin sauce",
                  localizedName: "hoisin sauce",
                  image: "dark-sauce.jpg",
                },
                {
                  id: 11291,
                  name: "green onions",
                  localizedName: "green onions",
                  image: "spring-onions.jpg",
                },
                {
                  id: 10114106,
                  name: "dry sherry",
                  localizedName: "dry sherry",
                  image: "dry-sherry.png",
                },
                {
                  id: 16124,
                  name: "soy sauce",
                  localizedName: "soy sauce",
                  image: "soy-sauce.jpg",
                },
                {
                  id: 0,
                  name: "marinade",
                  localizedName: "marinade",
                  image: "seasoning.png",
                },
                {
                  id: 2053,
                  name: "vinegar",
                  localizedName: "vinegar",
                  image: "vinegar-(white).jpg",
                },
                {
                  id: 11216,
                  name: "ginger",
                  localizedName: "ginger",
                  image: "ginger.png",
                },
                {
                  id: 23232,
                  name: "steak",
                  localizedName: "steak",
                  image: "ribeye-raw.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/japanese-steak-salad-648500",
    },
  },

  {
    id: 648470,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 25,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 3,
      spoonacularScore: 67.0,
      healthScore: 20.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 150.44,
      extendedIngredients: [
        {
          id: 11124,
          aisle: "Produce",
          image: "sliced-carrot.png",
          consistency: "solid",
          name: "carrots",
          nameClean: "carrot",
          original: "3 small carrots, chop bite size",
          originalName: "carrots, chop bite size",
          amount: 3.0,
          unit: "small",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "small",
              unitLong: "smalls",
            },
            metric: {
              amount: 3.0,
              unitShort: "small",
              unitLong: "smalls",
            },
          },
        },
        {
          id: 11352,
          aisle: "Produce",
          image: "potatoes-yukon-gold.png",
          consistency: "solid",
          name: "potatoes",
          nameClean: "potato",
          original: "2 potatoes, chopped bite size",
          originalName: "potatoes, chopped bite size",
          amount: 2.0,
          unit: "",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1 medium size onion, finely chopped",
          originalName: "onion, finely chopped",
          amount: 1.0,
          unit: "medium size",
          meta: ["finely chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "medium size",
              unitLong: "medium size",
            },
            metric: {
              amount: 1.0,
              unitShort: "medium size",
              unitLong: "medium size",
            },
          },
        },
        {
          id: 93605,
          aisle: "Ethnic Foods",
          image: "chili-paste.png",
          consistency: "solid",
          name: "curry paste",
          nameClean: "red curry paste",
          original:
            "1/2 package Japanese curry, such as S & B Golden Curry (look for this in the Asian section of supermarkets or on Amazon.com)",
          originalName:
            "Japanese curry, such as S & B Golden Curry (look for this in the Asian section of supermarkets or on Amazon.com)",
          amount: 0.5,
          unit: "package",
          meta: [
            " such as s & b golden curry (look for this in the asian section of supermarkets or on amazon.com)",
          ],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "pkg",
              unitLong: "packages",
            },
            metric: {
              amount: 0.5,
              unitShort: "pkg",
              unitLong: "packages",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "3 cups water",
          originalName: "water",
          amount: 3.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 709.764,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 4582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vegetable-oil.jpg",
          consistency: "liquid",
          name: "oil",
          nameClean: "cooking oil",
          original: "1 tablespoon neutral oil",
          originalName: "neutral oil",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["neutral"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 18337,
          aisle: "Refrigerated;Frozen",
          image: "puff-pastry.png",
          consistency: "solid",
          name: "puff pastry dough",
          nameClean: "puff pastry dough",
          original: "1 package puff pastry dough sheets",
          originalName: "puff pastry dough sheets",
          amount: 1.0,
          unit: "package",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "pkg",
              unitLong: "package",
            },
            metric: {
              amount: 1.0,
              unitShort: "pkg",
              unitLong: "package",
            },
          },
        },
      ],
      id: 648470,
      title: "Japanese Curry Puffs",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl:
        "https://www.foodista.com/recipe/BZSSYFKR/japanese-curry-puffs",
      image: "https://spoonacular.com/recipeImages/648470-556x370.jpg",
      imageType: "jpg",
      summary:
        'You can never have too many main course recipes, so give Japanese Curry Puffs a try. One serving contains <b>794 calories</b>, <b>12g of protein</b>, and <b>50g of fat</b>. For <b>$1.5 per serving</b>, this recipe <b>covers 24%</b> of your daily requirements of vitamins and minerals. This recipe serves 4. Head to the store and pick up water, oil, onion, and a few other things to make it today. 3 people found this recipe to be yummy and satisfying. This recipe is typical of Japanese cuisine. From preparation to the plate, this recipe takes around <b>around 45 minutes</b>. It is brought to you by Foodista. It is a good option if you\'re following a <b>dairy free, lacto ovo vegetarian, and vegan</b> diet. All things considered, we decided this recipe <b>deserves a spoonacular score of 66%</b>. This score is pretty good. Similar recipes are <a href="https://spoonacular.com/recipes/japanese-curry-729592">Japanese Curry</a>, <a href="https://spoonacular.com/recipes/japanese-curry-565220">Japanese Curry</a>, and <a href="https://spoonacular.com/recipes/japanese-curry-from-scratch-628206">Japanese Curry from Scratch</a>.',
      cuisines: ["Asian", "Japanese"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: [],
      winePairing: {},
      instructions:
        "Preheat oven to 350 degrees.\nIn a pot over medium/high heat, add oil and onions. Cook for 2 minutes. Add potatoes and carrots, cook for 5 minutes. Add water and bring to the boil. Lower heat and simmer for 15 minutes. Add curry mix and cook for another 10 minutes.\nOn a sheet pan, cut puff pastry into squares (1 sheet should give you 4 squares) and with a spoon, fill the middle of 1/2 of the squares you have.\nBake for 20 minutes or until the crust is a golden brown and serve!",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 350 degrees.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "In a pot over medium/high heat, add oil and onions. Cook for 2 minutes.",
              ingredients: [
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 2,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Add potatoes and carrots, cook for 5 minutes.",
              ingredients: [
                {
                  id: 11352,
                  name: "potato",
                  localizedName: "potato",
                  image: "potatoes-yukon-gold.png",
                },
                {
                  id: 11124,
                  name: "carrot",
                  localizedName: "carrot",
                  image: "sliced-carrot.png",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Add water and bring to the boil. Lower heat and simmer for 15 minutes.",
              ingredients: [
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [],
              length: {
                number: 15,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Add curry mix and cook for another 10 minutes.",
              ingredients: [
                {
                  id: 0,
                  name: "curry mix",
                  localizedName: "curry mix",
                  image: "",
                },
              ],
              equipment: [],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "On a sheet pan, cut puff pastry into squares (1 sheet should give you 4 squares) and with a spoon, fill the middle of 1/2 of the squares you have.",
              ingredients: [
                {
                  id: 18337,
                  name: "puff pastry sheets",
                  localizedName: "puff pastry sheets",
                  image: "puff-pastry.png",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 7,
              step: "Bake for 20 minutes or until the crust is a golden brown and serve!",
              ingredients: [
                {
                  id: 0,
                  name: "crust",
                  localizedName: "crust",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/japanese-curry-puffs-648470",
    },
  },
];
